import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { AngularSvgIconModule } from "angular-svg-icon";
import { OverlayBadgeModule } from "primeng/overlaybadge";
import { ApeLogoComponent } from "../ape-logo/ape-logo.component";
import { ApeHeaderHomeButtonComponent } from "../ape-header-home-button/ape-header-home-button.component";
import { ApeAvatarComponent } from "../ape-avatar/ape-avatar.component";
import { ApeHeaderNotificationButtonComponent } from "../ape-header-notification-button/ape-header-notification-button.component";
import { ApeHeaderMenuComponent } from "../ape-header-menu/ape-header-menu.component";
import { ApeHeaderHelpButtonComponent } from "../ape-header-help-button/ape-header-help-button.component";
import { UrlCollection } from "../../constants/url-collection";
import { UserDataService } from "../../services/data/user-data.service";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

/**
 * Componente header dell'applicazione
 * Gestisce la barra di navigazione principale con logo, pulsanti di azione e menu hamburger
 *
 * Caratteristiche:
 * - Pulsante Home per navigazione rapida
 * - Logo cliccabile
 * - Pulsanti di aiuto e notifiche (desktop)
 * - Avatar utente (desktop)
 * - Menu hamburger sempre visibile con drawer autonomo
 * - Supporto completo per accessibilità
 */
@Component({
  selector: "ape-header",
  standalone: true,
  imports: [
    CommonModule,
    AngularSvgIconModule,
    OverlayBadgeModule,
    ApeLogoComponent,
    ApeHeaderHomeButtonComponent,
    ApeAvatarComponent,
    ApeHeaderNotificationButtonComponent,
    ApeHeaderMenuComponent,
    ApeHeaderHelpButtonComponent
  ],
  templateUrl: "./ape-header.component.html"
})
export class ApeHeaderComponent {
  protected readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  /**
   * Evento emesso quando il bottone notifiche viene cliccato per aprire il sidenav
   */
  @Output() openNotificationSidenav = new EventEmitter<void>();

  /**
   * Evento emesso quando il bottone help viene cliccato per aprire il sidenav supporto
   */
  @Output() openSupportSidenav = new EventEmitter<void>();

  /**
   * Avatar dell'utente recuperato dal JWT payload
   */
  protected get userAvatar(): string {
    const loginInfo = this.userDataService.getJwtPayload();
    return loginInfo?.user?.avatarImage || "";
  }

  /**
   * Espone UrlCollection per l'uso nel template
   */
  protected readonly UrlCollection = UrlCollection;

  private userDataService = inject(UserDataService);

  constructor(private router: Router) {
  }

  /**
   * Nome e cognome dell'utente (dati reali, come nel menu)
   */
  protected get userFirstName(): string {
    const loginInfo = this.userDataService.getJwtPayload();
    return loginInfo?.user?.forename || "";
  }

  protected get userLastName(): string {
    const loginInfo = this.userDataService.getJwtPayload();
    return loginInfo?.user?.surname || "";
  }

  protected setRouteLogo(): string {
    return this.router.url.startsWith("/admin")
      ? UrlCollection.adminHomepage
      : UrlCollection.homepage;
  }
}
